var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"portfolio"}},[_c('iframe',{attrs:{"src":"https://docs.google.com/presentation/d/e/2PACX-1vSPhHb6E7_gfw5sTowWlGsO42SKo44ZpkW1ybdGyaNoth11PCWZbQULhpIOZZkDV9jsa0kfSlaDoqNv/embed?start=true&loop=true&delayms=60000","frameborder":"0","id":"slides_embed","allowfullscreen":"true","mozallowfullscreen":"true","webkitallowfullscreen":"true"}})])
}]

export { render, staticRenderFns }